import React from "react";

import { 
	Box,
	Button,
	Dialog,
	Tooltip,
	Chip,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Alert,
	DialogTitle,
	DialogContent,
	DialogActions,
	Divider,
	TextField
} from "@mui/material"

import { styled } from '@mui/material/styles';
import { tooltipClasses } from "@mui/material/Tooltip";
import {
	DataGridPro,
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	gridClasses,
	LicenseInfo,
	ptBR
} from '@mui/x-data-grid-pro';

import { ptBR as corePtBR } from '@mui/material/locale';

import {
	createTheme,
	ThemeProvider,
	StyledEngineProvider
} from '@mui/material/styles';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import HowToRegIcon from '@mui/icons-material/HowToReg';

import Modal from './Modal';
import Loading from '../../Loading';
import useValidationError from '../../ErrorValidation';
import useNotification from "../../Notification";

import * as moment from "moment";

import api from '../../../api';

import LoadingButton from '@mui/lab/LoadingButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import "./styles.css";
import { capitalize } from "../../../utils/capitalize";
import {
	stringOperators,
	dateOperators,
	booleanOperators,
	choiceOperators
} from "../../../utils/filterOperators";
import ConfirmationDialog from "../../Dialogs/Confirmation";
import ConfirmationDialogCaptcha from '../../Dialogs/ConfimationDialogCaptcha';
import { getSession, saveSession } from "../../../auth";
import userPermissions from "../../User/Permissions";

import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox"
import CloseIcon from "@mui/icons-material/Close"

import AddBotDialog from "../Email/AddBotDialog"

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATAGRID_LICENSE_KEY);

const theme = createTheme({
	palette: {
		primary: { main: '#21446C' },
	},
}, ptBR, corePtBR);

const KwikTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		fontSize: 15,
		padding: 10
	},
}));

class Users extends React.Component {
	_isMounted = false;

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			renderKey: 0,
			dataUsers: [],
			dataColumns: [],
			viewUser: {},
			showUpdateUser: false,
			showLogoutConfirmation: false,
			user_name: '',
			user_id: 0,
			confirmRequeue: false,
			isRequeueLoading: false,
			showCreateUser: false,
			updateUserState: null,
			owner: 0,
			showSmtpSettings: false,
			selectedUserId: null,
			selectedUserEmail: "",
			queues: []
		};

		this.groupColors = {
			administrador: '#C95F50',
			supervisor: '#5F8963',
			operador: '#21446c'
		};

		this.settings = {};

		this.user_id = getSession().profile.id
		this.groups = userPermissions()
	}



	CustomToolbar = () => {

		return (
			<GridToolbarContainer className={gridClasses.toolbarContainer}>
				<GridToolbarColumnsButton />
				<GridToolbarFilterButton />
				{this.groups.isAdmin &&
					<LoadingButton
						size="small"
						component="label"
						startIcon={<AddCircleIcon />}
						onClick={() => { this.openCreateModal() }}
					>
						Adicionar
					</LoadingButton>
				}
			</GridToolbarContainer>
		);
	}

	calculateScreenHeight = () => {
		const screenHeight = window.screen.height > 1200 ? 9 :
			window.screen.height > 1100 ? 8 :
				window.screen.height > 1000 ? 7 :
					window.screen.height > 900 ? 6 :
						window.screen.height > 800 ? 5 :
							window.screen.height > 700 ? 4 : 3;

		return screenHeight;
	}


	errorValidation = async (res) => {
		await useValidationError(res.status, res.message);
		await this.setState({ viewUser: {} });
	}

	openUpdateModal = async (data) => {
		await this.setState({
			viewUser: data,
			showUpdateUser: true,
			renderKey: Math.random()
		});

	}

	openDeleteModal = async (data) => {
		await this.setState({
			viewUser: data,
			showDeleteUser: true,
			owner: getSession().id,
			renderKey: Math.random()
		});

	}

	openCreateModal = async () => {
		if (this.settings.max_agents === this.state.dataUsers.length) {
			await useNotification(
				'Ops!',
				'Sua empresa atingiu o número máximo de usuários cadastrados.',
				'danger'
			);
			return;
		}

		await this.setState({ showUpdateUser: false });
		this.setState({ showCreateUser: true })
	}

	requeueAgentChats = () => {
		this.setState({ isRequeueLoading: true })
		api.post(`/api/IV/agents/${this.state.user_id}/requeue_chats/`)
			.then((res) => {
				if (res.status == 200) {
					if (this.state.updateUserState)
						this.state.updateUserState();
					else
						this.handleLogoffUser(this.state.user_id);
					this.setState({ confirmRequeue: false, updateUserState: null })
					return;
				}
				this.setState({ isRequeueLoading: false })
				throw res;
			})
			.catch(async (err) => {
				console.error(err);
				useNotification(
					'Ops!',
					'Ocorreu um erro no sistema',
					'danger'
				);
			});
		this.setState({ isRequeueLoading: false })
		this.setState({ confirmRequeue: false })
	}

	setUsersData = (data) => {
		const users = [];

		data.map(user => {
			let obj = user;

			obj.action = user;
			obj.first_name = user.first_name
			obj.last_name = user.last_name

			users.push(obj);
		});

		this.setState({
			dataUsers: users,
			renderKey: Math.random()
		});
	}

	getSettings = () => {

		this.setState({ loading: true });

		api.get(`/api/enterprises/${this.props.enterpriseId}/`)
			.then(async (res) => {
				if (res.status == 200 && this._isMounted) {
					this.settings = res.data;
					return;
				}
				throw res;
			}).catch((err) => {
				console.error(err);
			});

		this.setState({ loading: false });
	}

	getErrorMessage = (data, fallback = 'Ocorreu um erro no sistema') => {
		const normalizeMessage = (value) => {
			if (!value)
				return ''
			if (Array.isArray(value))
				return normalizeMessage(value[value.length - 1])
			if (typeof value === 'object') {
				if (value.message)
					return normalizeMessage(value.message)
				if (value.detail)
					return normalizeMessage(value.detail)
				if (value.user)
					return normalizeMessage(value.user)
				if (value.agent)
					return normalizeMessage(value.agent)
				if (value.email)
					return normalizeMessage(value.email)
				return normalizeMessage(Object.values(value).flat())
			}
			return String(value)
		}

		const message = normalizeMessage(data)
		const lowerMessage = message.toLowerCase()

		if (!message)
			return fallback
		if (message === 'Maximum number of extensions reached.')
			return 'O limite máximo de ramais foi atingido.'
		if (message === 'Cant modify an agent logged in.')
			return 'Não é possível alterar o ramal enquanto o operador estiver logado.'
		if (message === 'Couldnt modify agent lines.')
			return 'Não foi possível modificar as linhas do operador.'
		if (message === 'Couldnt modify agent.')
			return 'Não foi possível modificar o operador.'
		if (lowerMessage.includes('extension must be unique') || lowerMessage.includes('already exists'))
			return 'O número do ramal já está em uso.'
		if (lowerMessage.includes('not found'))
			return 'Registro não encontrado no InstantVoice. Confira as informações informadas.'
		if (lowerMessage.includes('missing argument') || lowerMessage.includes('is missing'))
			return 'Dados incompletos para configurar o ramal. Confira os campos obrigatórios.'
		return message
	}

	isValidIntegration = async (data) => {
		const hasValue = (key) => data.hasOwnProperty(key) && data[key] !== null && data[key] !== undefined && data[key] !== ""
		const operatorKeys = [
			"instantvoice_accountcode",
			"instantvoice_agent_code",
			"instantvoice_api_key",
			"instantvoice_url",
		]
		const hasInstantvoiceUrl = hasValue("instantvoice_url")
		const hasOperatorIntegration = operatorKeys.some((key) => hasValue(key))
		const hasAllOperatorIntegration = operatorKeys.every((key) => hasValue(key))

		if (!hasInstantvoiceUrl && !hasOperatorIntegration)
			return true

		if (hasInstantvoiceUrl && !hasOperatorIntegration)
			return true

		if (!hasInstantvoiceUrl || !hasAllOperatorIntegration) {
			useNotification(
				'Atenção!',
				'Para validar o operador externo, preencha URL, accountcode, chave de API e código do operador.',
				'warning'
			)
			return false
		}

		const response = await api.post("api/IV/agents/validate_integration/", {
			instantvoice_accountcode: data.instantvoice_accountcode,
			instantvoice_agent_code: data.instantvoice_agent_code,
			instantvoice_api_key: data.instantvoice_api_key,
			instantvoice_url: data.instantvoice_url,
		})
		if (response.status !== 200) {
			useNotification(
				'Ops!',
				this.getErrorMessage(response.data, 'Não foi possível validar a integração com o InstantVoice externo.'),
				'danger'
			)
			console.log(response.data)
			return false
		}
		return true
	}


	updateUser = async (idUser, body) => {
		this.setState({ loading: true });

		if (! await this.isValidIntegration(body)) {
			this.setState({ loading: false })
			return
		}

		if ('nickname' in body) {
			if (!('profile' in body))
				body['profile'] = {}
			body['profile']['nickname'] = body['nickname']
		}

		if ("telephone" in body) {
			if (!("profile" in body))
				body["profile"] = {}
			const telephone = (body["telephone"] || '').replace(/\D/g, "")
			body["profile"]["telephone"] = (telephone) ? `+55${telephone}` : ""
		}

		if ("can_create_template" in body) {
			if (! ("profile" in body))
				body["profile"] = {}
			body["profile"]["can_create_template"] = body["can_create_template"]
		}

		if ("can_create_contact_group" in body) {
			if (! ("profile" in body))
				body["profile"] = {}
			body["profile"]["can_create_contact_group"] = body["can_create_contact_group"]
		}

		// If we are deactivating a user, we should requeue first
		if (this.state.viewUser && body.is_active === false) {
			this.setState({ updateUserState: () => this.updateUser(idUser, body), user_id: this.state.viewUser.profile.agent_id })
			if (! await this.handleLogoffUser(this.state.viewUser.profile.agent_id, true)) {
				return
			} // if true, should continue, if false, should alert
		}

		api.patch(`/api/enterprises/${this.props.enterpriseId}/users/${idUser}/`, body)
			.then(async (res) => {
				
				if (res.status == 200) {
					useNotification(
						'Sucesso!',
						'Usuário alterado com sucesso.',
						'success'
					);

					if (getSession().id === res.data.id)
						saveSession(res.data)

					this.getUsers();
					this.setState({ showUpdateUser: false, viewUser: {}, loading: false });
					return;
				}

				this.setState({ loading: false });

				if (res.status == 400) {
					const message = this.getErrorMessage(res.data);
					useNotification(
						'Atenção!',
						message,
						'warning'
					);
					return;
				}
				throw err;
			})
			.catch(async (err) => {
				console.error(err);
				useNotification(
					'Ops!',
					'Ocorreu um erro no sistema',
					'danger'
				);
			});
	}

	createUser = async (body) => {

		this.setState({ loading: true });

		api.post(`/api/enterprises/${this.props.enterpriseId}/agents/`, body)
			.then(async (res) => {
				await this.setState({ loading: false });
				if (res.status === 400 && res.data && res.data.user &&
					res.data.user[0] === "User must be unique among mcdus, accountcode's queues and extensions") {
					useNotification(
						'Ops!',
						'O número do usuário deve ser único.',
						'danger'
					);
				}
				else if (res.status === 400 && 'email' in res.data && res.data['email'][0] === 'Operador with this email already exists.')
					useNotification(
						'Ops!',
						'Já existe um usuário cadastrado com esse e-mail.',
						'warning'
					);
				else if (res.status === 400)
					useNotification(
						'Atenção!',
						this.getErrorMessage(res.data, 'Não foi possível cadastrar o usuário.'),
						'warning'
					);
				else if (res.status !== 201)
					await useValidationError(res.status);
				else {
					await useNotification(
						'Sucesso!',
						'Usuário cadastrado com sucesso.',
						'success'
					);
					this.getUsers();
					this.setState({ showCreateUser: false });
				}
			})
			.catch((err) => {
				console.error(err);
			});

	}

	getUsers = () => {
		this.setState({ loading: true });

		api.get(`/api/enterprises/${this.props.enterpriseId}/users/`)
			.then(async (res) => {
				this.setState({ loading: false });
				if (res.status === 200 && this._isMounted)
					this.setUsersData(res.data);
			})
			.catch((err) => {
				console.error(err);
			});
	}

	getQueues = () => {
		api.get(`/api/enterprises/${this.props.enterpriseId}/queues/chat/`)
			.then(async (res) => {
				if (res.status === 200) {
					const queues = res.data
						.filter((q) => {
							const parts = (q.name || "").split("_")
							return !(parts[1] && parts[1].startsWith("0000"))
						})
						.map((q) => ({ id: q.id, name: q.description }))
					this.setState({ queues })
				}
			})
			.catch((err) => {
				console.error(err)
			})
	}

	generateDialog = () => {
		return (
			<Modal
				showUpdateUser={this.state.showUpdateUser}
				user={this.state.viewUser}
				groupColors={this.groupColors}
				enterpriseId={this.props.enterpriseId}
				createUser={(body) => this.createUser(body)}
				updateUser={(userId, body) => this.updateUser(userId, body)}
				handleClose={() => this.setState({ showUpdateUser: false })}
				key={this.state.renderKey}
				queues={this.state.queues}
			/>
		);
	}

	generateCreateDialog = () => {
		return (
			<Modal
				showCreateUser={this.state.showCreateUser}
				//user={this.state.viewUser}
				groupColors={this.groupColors}
				enterpriseId={this.props.enterpriseId}
				createUser={(body) => this.createUser(body)}
				handleClose={() => this.setState({ showCreateUser: false })}
				key={this.state.renderKey}
			/>
		);
	}

	toggleUserActive = async (userId, currentIsActive) => {
		try {
			const res = await api.patch(`/api/enterprises/${this.props.enterpriseId}/users/${userId}/toggle_active/`)
			if (res.status === 200) {
				useNotification(
					'Sucesso!',
					`Usuário ${currentIsActive ? 'desativado' : 'ativado'} com sucesso.`,
					'success'
				)
				this.getUsers()
			}
		} catch (err) {
			useNotification('Ops!', 'Não foi possível alterar o status do usuário.', 'danger')
		}
	}

	deleteUser = async (user, owner) => {
		if (getSession().id === user.id) {
			useNotification(
				'Ops!',
				'Não é possível excluir o seu próprio usuário.',
				'warning'
			)
			return
		}

		this.setState({ loading: true });
		const resLogout = await api.post(`/api/IV/agents/${user.profile.agent_id}/logout/`)
		this.setState({ loading: false });

		if (resLogout.status === 400) {
			if (resLogout.data === 'Você não pode deslogar com atendimentos em andamento')
				useNotification(
					'Ops!',
					'Não foi possível excluir o usuário, ele possui atendimentos em curso.',
					'danger'
				)
			else
				useNotification(
					'Ops!',
					'Algo deu errado, tente novamente, se o problema persistir, entre em contato com o nosso time de suporte.',
					'danger'
				)
			return
		}

		this.setState({ loading: true });
		const resDelete = await api.delete(`api/users/${user.id}/changeowner/${owner}/`, { timeout: 20000 })
		this.setState({ loading: false });

		if (resDelete.status === 204) {
			this.getUsers()
			this.setState({
				viewUser: {},
				showDeleteUser: false,
				renderKey: Math.random()
			})
			useNotification(
				'Sucesso!',
				'O usuário foi excluído com sucesso.',
				'success'
			)
		} else if (resDelete.data.user) {
			useNotification(
				'Atenção!',
				resDelete.data.user,
				'warning'
			)
		} else {
			useNotification(
				'Ops!',
				'Algo deu errado, tente novamente, se o problema persistir, entre em contato com o nosso time de suporte.',
				'danger'
			)
		}
	}

	handleLogoffUser = async (userid, bypass = false) => {
		this.setState({ loading: true });
		let retvalue = true
		const res = await api.post(`/api/IV/agents/${userid}/logout/`)

		if (res.status === 400) {
			if (res.data === 'Você não pode deslogar com atendimentos em andamento')
				this.setState({ confirmRequeue: true })
			else
				useNotification('Atenção!', res.data, 'warning');
			retvalue = false
		}

		if (!bypass)
			this.getUsers();

		this.setState({ loading: false });

		return retvalue
	}

	includesAdminOrSupervisor = (groups) => {
		const group_names = groups.map(each => each.name)
		if (group_names.includes('supervisor') || group_names.includes('administrador'))
			return true
		return false
	}

	openSmtpSettingsDialog = (settings) => {
		this.setState({ 
			showSmtpSettings: true,
			selectedUserId: settings.id,
			selectedUserEmail: settings.username
		})
	}

	componentWillMount() {
		this._isMounted = true;
		const user = getSession();
		const has_voice = user.profile.enterprise.has_voice || user.profile.enterprise.whatsapp_calling;
		const has_assistant = user.profile.enterprise.has_assistant;

		const dataColumns = [
			{ field: 'username', headerName: 'Usuário', flex: 1, filterOperators: stringOperators },
			{
				field: 'name', headerName: 'Nome', flex: 0.5, filterOperators: stringOperators,
				valueGetter: (params) => {
					return `${params.row.first_name} ${params.row.last_name}`
				}
			},
			{
				field: 'nickname', headerName: 'Apelido', flex: 0.5, filterOperators: stringOperators,
				valueGetter: (params) => {
					if (params.row.profile.nickname)
						return params.row.profile.nickname
					return
				}
			},
			{
				field: 'telephone', headerName: 'Telefone', flex: 0.5, filterOperators: stringOperators, hide: true,
				valueGetter: (params) => {
					if (params.row.profile.telephone)
						return params.row.profile.telephone
					return
				}
			},
			{
				field: 'last_login_local', type: 'dateTime', headerName: 'Último login', flex: 1, filterOperators: dateOperators, hide: true,
				renderCell: (params) => (
					<Box>
						{params.value ? moment(params.value).format("DD/MM/YYYY HH:mm:ss").toString() : ""}
					</Box>
				),
			},
			{
				field: 'groups', headerName: 'Grupos', flex: 1.25, filterable: false,
				renderCell: (params) => (
					<Box>
						{params.value.map(group => (
							<Chip
								style={{ marginRight: "0.25rem" }}
								label={capitalize(group.name)}
								color={group.name == "supervisor" ? "success" : group.name == "operador" ? "info" : "error"}
								size="small"
							/>
						))}
					</Box>
				),
			},
			{
				field: 'is_active', headerName: 'Ativo', flex: 0.25, filterOperators: booleanOperators,
				renderCell: (params) => (
					<Box>
						{params.value ? <CheckCircleIcon className="active-user" /> : <Cancel className="inactive-user" />}
					</Box>
				),
			},
			{
				field: 'agent', headerName: 'Online', flex: 0.25, filterOperators: booleanOperators,
				renderCell: (params) => {
					return (
						<Box>
							{params.row.profile.agent?.agentstatus == 'LOGIN'
								? <CheckCircleIcon className="active-user" />
								: <Cancel className="inactive-user" />
							}
						</Box>
					)
				},
			},
			// This is left commented case we need it in the future
			// {
			// 	field: 'can_create_template', headerName: 'Template', flex: 0.5, filterOperators: booleanOperators,
			// 	renderCell: (params) => {
			// 		let canCreate = params.row.profile.can_create_template
			// 		if (! canCreate) {
			// 			// Administrators and supervisors can create regardless
			// 			canCreate = params.row.groups.some(group => ["administrador", "supervisor"].some(role => group.name.includes(role)))
			// 		}
			// 		return (
			// 			<Box>
			// 				{canCreate 
			// 					? <CheckCircleIcon className="active-user" /> 
			// 					: <Cancel className="inactive-user" />
			// 				}
			// 			</Box>
			// 		)
			// 	},
			// },
		];

		if (has_voice) {
			let column = {
				field: 'profile', headerName: 'Voz', flex: 0.25, filterOperators: booleanOperators,
				renderCell: (params) => (
					<KwikTooltip
						title={params.value.agent?.preferred_interface
							? params.value.agent?.external_username
								? 'Ramal(Externo): ' + params.value.agent?.external_username
								: 'Ramal(Interno): ' + params.value.agent?.preferred_interface.split('_').pop()
							: 'Ramal não configurado'}
						placement="left"
						disableInteractive
						arrow
					>
						<Box>
							{params.value.agent?.preferred_interface
								? <CheckCircleIcon className="active-user" />
								: <Cancel className="inactive-user" />
							}
						</Box>
					</KwikTooltip>
				),
			};
			dataColumns.push(column);
		}

		if (has_assistant) {
			let column = {
				field: 'has_assistant', headerName: 'Cortex', flex: 0.25, filterOperators: booleanOperators,
				renderCell: (params) => (
					<Box>
						{params.row.profile.has_assistant
							? <CheckCircleIcon className="active-user" />
							: <Cancel className="inactive-user" />
						}
					</Box>
				),
			};
			dataColumns.push(column);
		}

		{
			let column = {
				field: 'scout', headerName: 'Scout', flex: 0.25, filterOperators: booleanOperators,
				renderCell: (params) => (
					<Box>
						{params.row.profile.scout
							? <CheckCircleIcon className="active-user" />
							: <Cancel className="inactive-user" />
						}
					</Box>
				),
			};
			dataColumns.push(column);
		}

		if (getSession().profile.enterprise.platforms.email) {
			dataColumns.push({
				field: "has_email_smtp", headerName: "SMTP", flex: 0.25, filterOperators: booleanOperators,
				renderCell: (params) => (
					<Box>
						{params.value
							? <CheckCircleIcon className="active-user" />
							: <Cancel className="inactive-user" />
						}
					</Box>
				),
			})	
		}

		dataColumns.push({
			field: 'action', headerName: 'Ações', sortable: false, filterable: false, flex: .75,
			renderCell: (params) => (
				<Box sx={{ display: "flex" }}>
					{this.groups.isAdmin && 
						<>
							{params.row.profile.agent && 
								<Tooltip title="Editar">
									<Button
										className="action-button"
										onClick={() => this.openUpdateModal(params.value)}
									>
										<EditIcon />
									</Button>
								</Tooltip>
							}
							{getSession().profile.enterprise.platforms.email && ! params.row.has_email_smtp &&
								<Tooltip title="Configurar SMTP">
									<Button className="action-button"
										onClick={() => this.openSmtpSettingsDialog(params.value)}>
										<ForwardToInboxIcon />
									</Button>
								</Tooltip>
							}
							<Tooltip title="Excluir">
								<Button className="action-button delete"
									onClick={() => this.openDeleteModal(params.value)}>
									<DeleteIcon />
								</Button>
							</Tooltip>
							{params.row.is_active && (
								<Tooltip title="Desativar">
									<Button className="action-button delete"
										onClick={() => this.toggleUserActive(params.row.id, true)}>
										<PersonOffIcon />
									</Button>
								</Tooltip>
							)}
							{!params.row.is_active && (
								<Tooltip title="Ativar">
									<Button className="action-button"
										onClick={() => this.toggleUserActive(params.row.id, false)}>
										<HowToRegIcon />
									</Button>
								</Tooltip>
							)}
						</>
					}
					{params.row.profile.agent?.agentstatus == 'LOGIN' && params.row.profile.id != this.user_id ?
						<>
							{(
								(this.groups.isSupervisor && !this.groups.isAdmin && !this.includesAdminOrSupervisor(params.row.groups)) || this.groups.isAdmin) &&
								<>
									<Tooltip title="Deslogar" >
										<Button className="action-button inactive-send"
											onClick={() => {
												this.setState({
													user_id: params.row.profile.agent_id,
													user_name: params.row.first_name,
													user_surname: params.row.last_name,
													showLogoutConfirmation: true
												})
											}}>
											<LogoutIcon />
										</Button>
									</Tooltip>
								</>
							}

						</>
						:
						null
					}
				</Box>
			),
		});

		this.state.dataColumns = dataColumns;

		this.getSettings();
		this.getUsers();
		this.getQueues()
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	createUserSmtp = async (data) => {
		const enterpriseId = getSession().profile.enterprise.id
		this.setState({ loading: true })

		const {imap_username, ...payload} = data

		const response = await api.post(`/api/enterprises/${enterpriseId}/email/`, {
			...payload,
			user_id: this.state.selectedUserId
		})
		this.setState({ loading: false })
		if (response.status !== 201) {
			if (response.status === 400 && response.data[0] === "Max amount of email boxes reached!") {
				useNotification(
					"Atenção!",
					"Não há mais licenças de e-mail disponíveis para sua conta.",
					"warning"
				)
				return
			}
			if (response.status === 403) {
				useNotification(
					"Falha de conexão!",
					"Não foi possível conectar ao servidor SMTP, reveja as configurações, ou entre em contato com nosso suporte.",
					"danger"
				)
				return
			}
			useNotification(
				"Ops!",
				"Ocorreu um erro no sistema.",
				"danger"
			)
			return
		}
		useNotification(
			"Sucesso",
			"Configurações de e-mail sainte registradas com sucesso.",
			"success"
		)
		this.setState({ showSmtpSettings: false, selectedUserId: null, selectedUserEmail: "" })
		this.getUsers()
	}

	render() {
		return (
			<>
				<Loading loading={this.state.loading} />
				{this.state.showSmtpSettings &&
					<AddBotDialog
						data={{}}
						handleClose={() => this.setState({ showSmtpSettings: false, selectedUserId: null, selectedUserEmail: "" })}
						submit={(data) => this.createUserSmtp(data)}
						userEmail={this.state.selectedUserEmail}
					/>
				}
				{this.state.showUpdateUser &&
					<Dialog open={true} fullWidth
						disablePortal
						disableEnforceFocus
						sx={{ position: 'absolute' }}
					>
						{this.generateDialog()}
					</Dialog>
				}
				{this.state.showCreateUser &&
					<Dialog open={true} fullWidth
						disablePortal
						disableEnforceFocus
						sx={{ position: 'absolute' }}
					>
						{this.generateCreateDialog()}
					</Dialog>
				}
				{this.state.showDeleteUser &&
					<>
						<ConfirmationDialogCaptcha open={this.state.showDeleteUser}
							title="Confirmação"
							description={
								<span>
									Ao concordar, o usuário
									<span style={{ 'fontWeight': 'bold' }}> {this.state.viewUser.first_name + ' ' + this.state.viewUser.last_name} </span>
									(e sua respectiva fila) serão excluídos do sistema, para confirmar a ação, digite:
									<span style={{ 'fontWeight': 'bold' }}> remover </span>
									no campo abaixo.
								</span>
							}
							handleClose={() => this.setState({
								viewUser: {},
								showDeleteUser: false,
								renderKey: Math.random()
							})}
							handleSubmit={() => this.deleteUser(this.state.viewUser, this.state.owner)}
							captcha="remover"
							components={
								<>
									<Alert severity={"info"} sx={{ marginTop: '1rem' }}>Todos os contatos particulares desse operador serão transferidos
										para o usuário selecionado abaixo, caso desejar, pode torná-los públicos.</Alert>
									<FormControl fullWidth size="small" className='owner-box-max-size' sx={{ marginTop: '1rem' }}>
										<InputLabel id="notification-opt-out-label">Novo dono</InputLabel>
										<Select
											labelId="notification-opt-out-label"
											value={this.state.owner}
											label="Novo dono"
											onChange={(event) => this.setState({owner: event.target.value})}
										>
											<MenuItem id='user-item-none' value={0}>Público</MenuItem>
											{this.state.dataUsers.map((item) => (
												<MenuItem id={`user-item-${item.id}`} value={item.id}>{item.first_name} {item.last_name} - {item.username}</MenuItem>
											))}
										</Select>
									</FormControl>
								</>
							}
						/>

					</>
				}
				<ConfirmationDialog open={this.state.confirmRequeue}
					title="Não é permitido deslogar com chats em atendimento"
					description={(
						<Box>
							Deseja que os chats em atendimento sejam
							transferidos de volta para suas respectivas
							filas de origem?
						</Box>
					)}
					handleClose={() => this.setState({ confirmRequeue: false })}
					handleSubmit={() => this.requeueAgentChats()}
					submitButtonLoading={this.state.isRequeueLoading}
				/>
				<ConfirmationDialog open={this.state.showLogoutConfirmation}
					title="Logout"
					description={(
						<Box>
							Deseja realizar logout do usuário {this.state.user_name}?
						</Box>
					)}
					handleClose={() => this.setState({ showLogoutConfirmation: false })}
					handleSubmit={() => {
						this.handleLogoffUser(this.state.user_id)
						this.setState({ showLogoutConfirmation: false })
					}}
					submitButtonLoading={false}
				/>
				<Box className='settings-body-bot' key={this.state.renderKey}>
					<StyledEngineProvider injectFirst>
						<ThemeProvider theme={theme}>
							<DataGridPro
								rowsPerPageOptions={[25, 50, 100]}
								initialState={{ pagination: { pageSize: 25 } }}
								pagination
								disableSelectionOnClick
								disableDensitySelector
								density="compact"
								columns={this.state.dataColumns}
								rows={this.state.dataUsers}
								getRowClassName={(params) => !params.row.is_active ? 'row-disabled-user' : ''}
								components={{
									Toolbar: this.CustomToolbar,
								}}
							/>
						</ThemeProvider>
					</StyledEngineProvider>
				</Box>
			</>
		);
	}
}

export default Users;